import { useState, useCallback } from 'react';
import { apiClient } from '../api/client';

export interface Org {
  id: string;
  name: string;
  slug: string;
  plan: string;
  max_users: number;
  active: boolean;
  created_at: string;
}

export function useOrg() {
  const [org, setOrg] = useState<Org | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchOrg = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await apiClient.get<Org>('/orgs/me');
      setOrg(data);
      setError(null);
    } catch (err: any) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const updateOrg = async (payload: { name?: string }) => {
    await apiClient.patch('/orgs/me', payload);
    await fetchOrg();
  };

  return {
    org,
    isLoading,
    error,
    fetchOrg,
    updateOrg,
  };
}
